import type { ReactNode } from 'react';
import { Box, Paper, Typography } from '@mui/material';

/** Cadre des pages publiques (connexion, activation, mot de passe oublié). */
export default function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 4,
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 420 }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Box
            component="img"
            src="/logo-noir.svg"
            alt="JustiSch"
            sx={{ height: 64, mb: 1.5, filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))' }}
          />
          <Typography component="h1" variant="h4" sx={{ fontWeight: 700 }}>
            JustiSch
          </Typography>
        </Box>
        <Paper elevation={8} sx={{ p: { xs: 3, sm: 4 }, borderRadius: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
            {title}
          </Typography>
          {children}
        </Paper>
      </Box>
    </Box>
  );
}
